export default {
  data() {
    return {
      inputUrl: '',
      outputUrl: ''
    };
  },
  methods: {
    encodeUrl() {
      this.outputUrl = encodeURIComponent(this.inputUrl);
    },
    decodeUrl() {
      this.outputUrl = decodeURIComponent(this.inputUrl);
    }
  }
};